export default "__VITE_ASSET__BO9FR7Cf__"